export enum RepairshopStepEnum {
  BASIC = 'basic',
  ADDRESS = 'address',
  OVERVIEW = 'overview',
}
